import { render, staticRenderFns } from "./PaymentSelectItem.vue?vue&type=template&id=5666c328&"
import script from "./PaymentSelectItem.vue?vue&type=script&lang=ts&"
export * from "./PaymentSelectItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports